<script>
export default {
  name: 'FCSubscriptions',
  data() {
    return {
      tableFields: [
        { key: 'emailList', label: 'List Name' },
        'description',
        { key: 'toggle', label: 'Subscribed' }
      ],
      tableData: []
    }
  },
  computed: {
    fcEmailListsQuery: function() {
      return this.buildGraphqlQuery(
        'allEmailLists',
        [
          {
            nodes: true,
            fields: [
              { field: 'emailList' },
              { field: 'topicsList', alias: 'description' },
              { field: 'userIsSubscribed', alias: 'toggle' }
            ]
          }
        ],
        {
          conditions: {
            listLevel: { default: 'F' },
            active: { type: 'Boolean', default: true }
          }
        }
      )[0]
    },
    fcEmailToggleMutation: function() {
      return this.buildGraphqlMutation(
        'toggleCurrentPersonFCSubscription',
        [
          {
            name: 'input',
            params: [
              { field: 'emailList', required: true },
              { field: 'toggle', type: 'Boolean', required: true }
            ]
          }
        ],
        ['clientMutationId'],
        {
          mutationName: 'fcEmailToggleMutation'
        }
      )
    }
  },
  methods: {
    getLists() {
      this.graphqlAllPages(this.fcEmailListsQuery).then(data => {
        this.tableData = data.allEmailLists.nodes
      })
    },
    listToggle(data) {
      this.graphql(this.fcEmailToggleMutation, data)
    }
  },
  mounted() {
    this.getLists()
  }
}
</script>

<template>
  <div>
    <ResultsTable
      :fields="tableFields"
      :results="tableData"
      @toggleItem="listToggle"
    />
  </div>
</template>
